import { BackedApi } from "../../config/urls/Api";
import { StorageService } from "../storage.service";
import { DrillSessionQuota } from "../session-quota/drill-session-quota";

export interface AuthMeResponse {
    authorized: boolean;
    status: number;
    name?: string;
    plan?: string;
    planDuration?: number;
    drills?: DrillSessionQuota[];
}

interface AuthMeApiBody {
    userId?: string;
    name?: string;
    planName?: string;
    planDuration?: number;
    drills?: DrillSessionQuota[];
}

export class AuthRepository {
    static async me(): Promise<AuthMeResponse> {
        try {
            const response = await fetch(BackedApi.AuthMe.url, {
                method: BackedApi.AuthMe.method,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const authorized = response.status !== 401;

            if (!authorized) {
                return {
                    authorized: false,
                    status: response.status,
                };
            }

            const body = (await response.json()) as AuthMeApiBody;
            const name = body.name ?? "";
            const plan = body.planName ?? 'free';

            StorageService.setUsers({ name, plan });

            return {
                authorized: true,
                status: response.status,
                name,
                plan,
                planDuration: body.planDuration,
                drills: body.drills,
            };
        } catch (error) {
            return {
                authorized: false,
                status: 500,
            };
        }
    }
}
